import { render } from "./RealizarAssinaturaDeclaracao.vue?vue&type=template&id=f66ea5f2&scoped=true"
import script from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"
export * from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"

import "./RealizarAssinaturaDeclaracao.vue?vue&type=style&index=0&id=f66ea5f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66ea5f2"]])

export default __exports__